import { roundDecimalPlaces, distanceConnect } from './utils.js'


class ShapeConnectSeries {

    constructor(
        shape,
    ) {
        this.shape = shape
    }

    // Determine the parameter for the each end of the object on the shape 
    // Not doing any size calculations yet, so just need the arc and step information
    // args - An instance of the `ConnectingShapeArgs` object
    getShapeOuterParams(args) {
        let outerParams = []
        let start, end, arcSize, stepSize
        let arcRepeat, stepRepeat
        let arcReps = args.arcChangeRepeat.length
        let stepReps = args.stepChangeRepeat.length
        let changeStep = [1, 1]
        let changeArc = [1, 1]
        // Only apply it to the leading part of the shape
        let prevStart = [0, args.gap]
        for (let k = 0; k < args.maxConnect; k++) {
            for (let i = 0; i < 2; i++) {
                // Repeats apply to both sequential and group
                arcRepeat = args.arcChangeRepeat[k % arcReps][i]
                stepRepeat = args.stepChangeRepeat[k % stepReps][i]
                arcSize = args.arc[i] * changeArc[i]
                stepSize = args.step[i] * changeStep[i]
                start = roundDecimalPlaces(prevStart[i] + stepSize * stepRepeat, 4)
                end = roundDecimalPlaces(start + arcSize * arcRepeat, 4)
                outerParams.push(start, end)
                // Do these every loop when not using groups
                prevStart[i] = start
                changeArc[i] += changeArc[i] * args.arcChange[i]
                changeStep[i] += changeStep[i] * args.stepChange[i]
            }
        }
        return outerParams
    }

    getConnectingPoints(args, outerParams) {
        let curvePoints = []
        // Extents are analogous to the distances but serve to tell 
        // the shapes involved how to scale the relative arcs
        let extents = []
        let distanceZero, distanceOne
        let changeSize = [1, 1] 
        let sizes = args.size.slice(0)
        for (let i = 0; i < outerParams.length - 3; i+=4) {
            distanceZero = sizes[0] * changeSize[0]
            distanceOne = sizes[1] * changeSize[1]
            extents = extents.concat([changeSize[0] * args.arcAdjust[0], changeSize[1] * args.arcAdjust[1]])
            // These point will be from higher to lower params,
            // forming the start arc of the shape
            curvePoints.push(distanceConnect(this.shape, outerParams[i + 3], outerParams[i], distanceZero))
            curvePoints.push(distanceConnect(this.shape, outerParams[i + 2], outerParams[i + 1], distanceZero))
            // and these will be from lower to higher params,
            // the end arc
            curvePoints.push(distanceConnect(this.shape, outerParams[i + 1], outerParams.at(i + 2), distanceOne))
            curvePoints.push(distanceConnect(this.shape, outerParams[i], outerParams[i + 3], distanceOne))
            changeSize[0] += changeSize[0] * args.sizeChange[0]
            changeSize[1] += changeSize[1] * args.sizeChange[1]
        }
        return [extents, curvePoints]
    }

    buildConnecting(args, shape, points, params, extent) {
        let path = ``

        // Go to start
        path = `${path} M ${points[0].x} ${points[0].y} `

        // Draw arc for lower param edge of the shape
        path = args.connectPoints ? `${path} L ${points[1].x} ${points[1].y} ` : `${path} ${shape.getSubCurveRelative(...params.slice(0, 2), extent[0])} `

        // Go to start of outer arc
        path = `${path} L ${points[2].x} ${points[2].y} `

        // Draw outer arc or line
        path = args.connectPoints ? `${path} L ${points[3].x} ${points[3].y} ` : `${path} ${shape.getSubCurveRelative(...params.slice(2, 4), extent[1])} `

        // Line back to start
        path = `${path} L ${points[0].x} ${points[0].y} `
        return path
    }


    getConnectingShapes(args, outerParams, curvePoints, extents) {
        let shapePaths = []
        for (let i = 0; i < curvePoints.length - 3; i+=4) {
            let points = curvePoints.slice(i, i + 4)
            let params = outerParams.slice(i, i + 4)
            let extent = extents.slice(i / 2, i / 2 + 2)
            shapePaths.push(this.buildConnecting(args, this.shape, points, params, extent))
        }
        return shapePaths
    }


    getConnecting(args) {
        let maxConnect = args.maxConnect === 0 ? 1 / args.step : args.maxConnect
        args.setMaxConnect(maxConnect)
        let outerParams = this.getShapeOuterParams(args)
        let [extents, curvePoints] = this.getConnectingPoints(args, outerParams)
        let connectingShapes = this.getConnectingShapes(args, outerParams, curvePoints, extents)
        return [connectingShapes, curvePoints]
    }

    // Center shape - or Multi Shape? 
    // This would allow making shapes from the center toward outside 
    // if it seems useful to do so. 
    // Could replicate the various interleave/repeated shape 
    // patterns that something like radials will not. Could also 
    // use the center offset to see if that helps with interesting shapes.

}

export { ShapeConnectSeries }
